

import { Validators } from "@angular/forms";
import { BsDatepickerConfig } from "ngx-bootstrap/datepicker";


export interface FormPaxesReservationData {

  getClientsSettingAppBooking: any;
  styleSidebar: any;
  dpConfig: Partial<BsDatepickerConfig>,
  minDateAdult: Date;
  maxDateChild: Date;
  maxDateAdult: Date;

  resultReserve: any[];
  // clientes & clientes asociados
  clientArr: any[];
  clientsAssociated: any[];
  numberDocumentClient: any[];
  clientsAssociatedSelected: boolean;
  clientIdArr: any[];

    // utilidades
  countries: any[];
  states: any[];
  cities: any[];
  relationShips: any[];
  relationChild: any[];
  adultsPax: any[];
  documentTypes: any[];

  paxList: any[];

  reserving: boolean;

  formInvalid: boolean;

    // complete child whit parent
  email_parent: string;
  address_parent: string;
  city_parent: string;
  type_document_parent: string;
  country_parent: string;
  state_parent: string;
  phone_code_parent: string;

  relationShip: any;
  phone_code: any;
  phone_code_2: any;

  // validate number document
  documentErrorDuplicate: boolean;
  documentClientExists: boolean;
  documentNumberPaxlistArrAux: any[];
  typeDocumentSelect: number;
  indexPaxTypeDocumentSelect: number;

  //asociated client
  booleanHeadline: boolean;

  booleanSelectCountries: boolean;
  booleanSelectState: boolean;

  generalForm: any,

  contadorBirthDate: number;

}

export const formPaxesReservationData: FormPaxesReservationData = {

  getClientsSettingAppBooking: {},
  styleSidebar: {},
  dpConfig: new BsDatepickerConfig(),
  minDateAdult: new Date,
  maxDateChild: new Date,
  maxDateAdult: new Date,

  resultReserve: [],
    // clientes & clientes asociados
  clientArr: [],
  clientsAssociated: [],
  numberDocumentClient: [],
  clientsAssociatedSelected: false,
  clientIdArr: [],

  // utilidades
  countries: [],
  states: [],
  cities: [],
  relationShips: [],
  relationChild: [],
  adultsPax: [],
  documentTypes: [],

  paxList: [],

  //generate payload reserve
  reserving: false,

  formInvalid: false,

  // complete child whit parent
  email_parent: null,
  address_parent: null,
  city_parent: null,
  type_document_parent: null,
  country_parent: null,
  state_parent: null,
  phone_code_parent: null,

  relationShip: null,
  phone_code: null,
  phone_code_2: null,

  // validate number document
  documentErrorDuplicate: false,
  documentClientExists: false,
  documentNumberPaxlistArrAux: [],
  typeDocumentSelect: null,
  indexPaxTypeDocumentSelect: null,

  //asociated client
  booleanHeadline: false,

  booleanSelectCountries: false,
  booleanSelectState: false,

  generalForm: null,

  contadorBirthDate: 0,


}

export interface PaxEmpty {
  gender: any,
  clientId: any,
  address: any,
  birth_date: any,
  city: any,
  clientSelected: any,
  country_id: any,
  document_number: any,
  document_type_number: any,
  document_type_id: any,
  email: any,
  first_name: any,
  idUnique: any,
  last_name: any,
  phone: any,
  phone_2: any,
  phone_2_code: any,
  phone_2_code_selected: any,
  phone_code: any,
  phone_code_selected: any,
  postal_code: any,
  relation_ship: any,
  relation_ship_catalogue_id: any,
  state_id: any,
  title:any,
  type?: string,
  paxOptional?: boolean
}


export const paxEmpty: PaxEmpty = {
  gender: null,
  clientId: null,
  address: null,
  birth_date: null,
  city: null,
  clientSelected: null,
  country_id: null,
  document_number: null,
  document_type_number: null,
  document_type_id: null,
  email: null,
  first_name: null,
  idUnique:  getRandom(),
  last_name: null,
  phone: null,
  phone_2: null,
  phone_2_code: null,
  phone_2_code_selected: null,
  phone_code: null,
  phone_code_selected: null,
  postal_code: null,
  relation_ship: null,
  relation_ship_catalogue_id: null,
  state_id: null,
  title: null,
  type: null,
  paxOptional: null,
}

export function getRandom(): number {
      return Math.floor(Math.random() * 20000000000000) + Date.now();
}

export interface Titles {
  id: string;
  name: string;
}


export const titles: Titles[] =[

    { id: "Mr.", name: "Mr." },
    { id: "Mrs.", name: "Mrs." },
    { id: "Ms.", name: "Ms." },

]

export interface RoutesAPI {
  app: string,
  api: string,
  countries: string;
  states: string;
  cities: string;
  updatePaxlist: string;
  reservation: string;
  reservation_confirmation: string;
  relation_ship_catalogue: string;
  document_type: string;
}

  export const routes: RoutesAPI = {
    app: "app",
    api: "api",
    countries: '/utilities/countries',
    states: '/utilities/destinations/',
    cities: '/utilities/cities/',
    updatePaxlist: 'itineraries/update/paxlist/',
    relation_ship_catalogue: 'relationShips',
    reservation: '/reservation',
    reservation_confirmation: '/reservation-confirmation',
    document_type: 'documentTypes'
  }

  // Validaciones para el primer pasajero (Adulto - TODOS los campos obligatorios)
  export const ValidateFormFirstPaxes = [
    { key: 'gender', required: true },
    { key: 'title', required: true },
    { key: 'first_name', required: true },
    { key: 'last_name', required: true },
    { key: 'birth_date', required: true },
    { key: 'document_type_id', required: true },
    { key: 'document_number', required: true },
    { key: 'email', required: true },
    { key: 'country_id', required: true },
    { key: 'phone_code', required: true },
    { key: 'phone', required: true }
  ];

  // Validaciones para el primer pasajero - Solo Transporte
  export const ValidateFormOnlyTransport = [
    { key: 'title', required: true },
    { key: 'first_name', required: true },
    { key: 'last_name', required: true },
    { key: 'phone_code', required: true },
    { key: 'phone', required: true },
    { key: 'country_id', required: true }
  ];

  // Validaciones para el segundo pasajero (Adulto - Campos básicos + opcionales)
  export const ValidateFormSecondPaxes = [
    { key: 'gender', required: true },
    { key: 'title', required: true },
    { key: 'first_name', required: true },
    { key: 'last_name', required: true },
    { key: 'birth_date', required: true },
    { key: 'document_type_id', required: true },
    { key: 'document_number', required: true },
    { key: 'phone_code', required: true },
    { key: 'phone', required: true },
    { key: 'country_id', required: true },
    // Campos opcionales
    { key: 'relation_ship', required: false },
    { key: 'postal_code', required: false },
    { key: 'phone_2', required: false },
    { key: 'phone_2_code', required: false }
  ];

  // Validaciones para el tercer pasajero o niños (Solo nombre y fecha)
  export const ValidateFormThirdOrChildren = [
    { key: 'title', required: true },
    { key: 'first_name', required: true },
    { key: 'last_name', required: true },
    { key: 'birth_date', required: true },
    { key: 'country_id', required: true },
    // Campos opcionales
    { key: 'relation_ship', required: false },
    { key: 'postal_code', required: false },
    { key: 'phone_2', required: false },
    { key: 'phone_2_code', required: false }
  ];

  // Validaciones genéricas por tipo de pasajero
  export const ValidateFormByType = {
    firstAdult: ValidateFormFirstPaxes,
    secondAdult: ValidateFormSecondPaxes,
    thirdOrMoreAdult: ValidateFormThirdOrChildren,
    child: ValidateFormThirdOrChildren,
    onlyTransport: ValidateFormOnlyTransport
  };

  // Mapeo de campos obligatorios vs opcionales
  export const ValidationFieldGroups = {
    required: {
      firstAdult: ['gender', 'title', 'first_name', 'last_name', 'birth_date', 'document_type_id', 'document_number', 'email', 'country_id', 'phone_code', 'phone'],
      secondAdult: ['gender', 'title', 'first_name', 'last_name', 'birth_date', 'document_type_id', 'document_number', 'phone_code', 'phone'],
      thirdOrChild: ['title', 'first_name', 'last_name', 'birth_date'],
      onlyTransport: ['first_name', 'last_name', 'phone_code', 'phone']
    },
    optional: {
      adult: ['relation_ship', 'postal_code', 'phone_2', 'phone_2_code'],
      child: ['relation_ship', 'postal_code', 'phone_2', 'phone_2_code']
    }
  };

  export function getValidationsForIndex(index: number, paxList: any[], onlyTransports: boolean = false): { key: string; required: boolean }[] {
    // Si es solo transporte
    if (onlyTransports && index === 0) {
      return ValidateFormOnlyTransport;
    }

    const paxType = paxList[index]?.type;
    const isChild = paxType === 'children';

    // Primer pasajero (índice 0)
    if (index === 0) {
      return ValidateFormFirstPaxes;
    }

    // Segundo pasajero (índice 1)
    if (index === 1 && !isChild) {
      return ValidateFormSecondPaxes;
    }

    // Tercer pasajero o más, o niños
    return ValidateFormThirdOrChildren;
  }

  export function isFieldRequired(index: number, fieldKey: string, paxList: any[], onlyTransports: boolean = false): boolean {
    const validations = getValidationsForIndex(index, paxList, onlyTransports);
    const field = validations.find(v => v.key === fieldKey);
    return field ? field.required : false;
  }

  // Función para obtener todos los campos requeridos para un índice
  export function getRequiredFields(index: number, paxList: any[], onlyTransports: boolean = false): string[] {
    const validations = getValidationsForIndex(index, paxList, onlyTransports);
    return validations.filter(v => v.required).map(v => v.key);
  }

  // Función para obtener todos los campos opcionales para un índice
  export function getOptionalFields(index: number, paxList: any[], onlyTransports: boolean = false): string[] {
    const validations = getValidationsForIndex(index, paxList, onlyTransports);
    return validations.filter(v => !v.required).map(v => v.key);
  }


  // validation-config.ts

export interface FieldValidationConfig {
  required: boolean;
  validators: any[];
  errorMessages?: { [key: string]: string };
}

export interface PaxValidationConfig {
  [fieldName: string]: FieldValidationConfig;
}
// Solo Transporte - SOLO el primer pasajero (índice 0) tiene validación
export const OnlyTransportValidation: PaxValidationConfig = {
  title: { required: true, validators: [Validators.required] },
  first_name: {
    required: true,
    validators: [
      Validators.required,
      Validators.minLength(2),
      Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)
    ]
  },
  last_name: {
    required: true,
    validators: [
      Validators.required,
      Validators.minLength(2),
      Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)
    ]
  },
  email: {
    required: true,
    validators: [Validators.required, Validators.email]
  },
  phone: {
    required: true,
    validators: [Validators.required, Validators.pattern(/^\d{6,}$/)]
  },
  phone_code: {
    required: true,
    validators: [Validators.required]
  },
  country_id: { required: true, validators: [Validators.required] }
};

// Primer pasajero (Adulto) - TODOS los campos obligatorios
export const FirstPaxValidation: PaxValidationConfig = {
  gender: { required: true, validators: [Validators.required] },
  title: { required: true, validators: [Validators.required] },
  first_name: {
    required: true,
    validators: [
      Validators.required,
      Validators.minLength(2),
      Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)
    ]
  },
  last_name: {
    required: true,
    validators: [
      Validators.required,
      Validators.minLength(2),
      Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)
    ]
  },
  birth_date: { required: true, validators: [Validators.required] },
  document_type_id: { required: true, validators: [Validators.required] },
  document_number: { required: true, validators: [Validators.required] },
  email: { required: true, validators: [Validators.required, Validators.email] },
  phone: { required: true, validators: [Validators.required, Validators.pattern(/^\d{6,}$/)] },
  phone_code: { required: true, validators: [Validators.required] },
  country_id: { required: true, validators: [Validators.required] },
};

// Segundo pasajero (Adulto) - Campos básicos obligatorios
export const SecondPaxValidation: PaxValidationConfig = {
  gender: { required: true, validators: [Validators.required] },
  title: { required: true, validators: [Validators.required] },
  first_name: {
    required: true,
    validators: [
      Validators.required,
      Validators.minLength(2),
      Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)
    ]
  },
  last_name: {
    required: true,
    validators: [
      Validators.required,
      Validators.minLength(2),
      Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)
    ]
  },
  birth_date: { required: true, validators: [Validators.required] },
  document_type_id: { required: true, validators: [Validators.required] },
  document_number: { required: true, validators: [Validators.required] },
  phone: { required: true, validators: [Validators.required, Validators.pattern(/^\d{6,}$/)] },
  phone_code: { required: true, validators: [Validators.required] },
  country_id: { required: true, validators: [Validators.required] }
  // NOTA: email, state_id, city, address, relation_ship NO están en la configuración
  // Por lo tanto NO mostrarán validación aunque estén en el HTML
};

// Tercer pasajero o niños - Campos básicos
export const ChildOrThirdPaxValidation: PaxValidationConfig = {
  gender: { required: true, validators: [Validators.required] },
  title: { required: true, validators: [Validators.required] },
  first_name: {
    required: true,
    validators: [
      Validators.required,
      Validators.minLength(2),
      Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)
    ]
  },
  last_name: {
    required: true,
    validators: [
      Validators.required,
      Validators.minLength(2),
      Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)
    ]
  },
  birth_date: { required: true, validators: [Validators.required] },
  document_type_id: { required: true, validators: [Validators.required] },
  document_number: { required: true, validators: [Validators.required] },
  phone: { required: true, validators: [Validators.required, Validators.pattern(/^\d{6,}$/)] },
  phone_code: { required: true, validators: [Validators.required] },
  country_id: { required: true, validators: [Validators.required] }
};

export const ClientMainValidation: PaxValidationConfig = {
  gender: { required: true, validators: [Validators.required] },
  title: { required: true, validators: [Validators.required] },
  first_name: {
    required: true,
    validators: [
      Validators.required,
      Validators.minLength(2),
      Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)
    ]
  },
  last_name: {
    required: true,
    validators: [
      Validators.required,
      Validators.minLength(2),
      Validators.pattern(/^[a-zA-ZÀ-ÿ\u00f1\u00d1\s]+$/)
    ]
  },
  birth_date: { required: true, validators: [Validators.required] },
  country_id: { required: true, validators: [Validators.required] },
  document_type_id: { required: true, validators: [Validators.required] },
  document_number: { required: true, validators: [Validators.required] },
  email: { required: true, validators: [Validators.required, Validators.email] },
  phone: { required: true, validators: [Validators.required, Validators.pattern(/^\d{6,}$/)] },
  phone_code: { required: true, validators: [Validators.required] },
  phone_2: { required: false, validators: [Validators.pattern(/^\d{6,}$/)] },
  phone_2_code: { required: false, validators: [] },
  city: { required: false, validators: [] },
  state_id: { required: false, validators: [] },
  address: { required: false, validators: [Validators.minLength(5)] },
  postal_code: { required: false, validators: [Validators.minLength(4)] },
  relation_ship: { required: false, validators: [] }
};
